let domLoaded = false;
let igReady = false;

function handleExperiments() {
  if (!domLoaded || !igReady) return;
  //V_PC_COL_12 | Image Slider on Product Grid Thumbnails

  const c_Image_Slider_on_Product_Grid_Thumbnails = window.igData?.user.getTestGroup(
    "8c894efc-b706-417d-b14f-5704965f476f"
  );
  if (c_Image_Slider_on_Product_Grid_Thumbnails?.name === "Var A") {
    document.body.classList.add(
      "c-image-slider-on-product-grid-thumbnails-VarA"
    );
  }
  //Mobile Nav Menu test
  const c_Mobile_Nav_Test = window.igData?.user.getTestGroup(
    "759ae9cb-c75a-4035-8488-add8effafbc7"
  );
  if (c_Mobile_Nav_Test?.name === "Var A") {
    document.body.classList.add("c-mobilenav");
  }

  //Checkout btn Test
  const c_Checkout_btn_Test = window.igData?.user.getTestGroup(
    "67867c61-bfce-4c92-8cd0-42dbbfea5d76"
  );
  if (c_Checkout_btn_Test?.name === "Var A") {
    document.body.classList.add("checkout-test-VarA");
  } else if (c_Checkout_btn_Test?.name === "Var B") {
    document.body.classList.add("checkout-test-VarB");
  }
  
  //Header menu cart label Test
  const c_Header_Test = window.igData?.user.getTestGroup(
    "a08f6a02-2a75-45a3-9db9-9706343e8685"
  );
  if (c_Header_Test?.name === "Var A") {
    document.body.classList.add("c-menu-cart-label-test-VarA");
  }
}

document.addEventListener("DOMContentLoaded", () => {
  domLoaded = true;
  handleExperiments();
});

window.addEventListener("ig:ready", () => {
  igReady = true;
  handleExperiments();
});
